import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import {diamondImgUrl, diamondTitle, diamondPrice} from '../../../../../utils/formatting';

import * as productActionCreators from '../../../../../actions/product';
let allActionCreators = Object.assign({}, productActionCreators);



class FloatingHeader extends React.Component {

  static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

  constructor(props) {

    super(props);
    this.state = {
      scrollPos: 0,
    };

    // Bind event listeners
    this.getScrollPos = ::this.getScrollPos;
  }

  componentDidMount() {
    window.addEventListener('scroll', this.getScrollPos, false);
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.product.selectedDiamond === null && prevProps.product.selectedSetting === null) {
      if(this.isSettingSelected() || this.isDiamondSelected()) {
        // this.setState({ floatOpen: true });
        this.props.productToggleFloatingHeader(true);
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.getScrollPos, false);
  }

  getScrollPos() {
    this.setState({
      scrollPos: window.pageYOffset,
    })
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

  externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  selectDiamond(diamond) {
    this.props.productSelectDiamond(diamond);
  }

  isDiamondSelected() {
    return this.props.product.selectedDiamond !== null;
  }

  selectSetting(product) {
    this.props.productSelectSetting(product);
  }

  isSettingSelected() {
    return this.props.product.selectedSetting !== null;
  }

  getProductMainImage(product) {
    if(product.image_count > 0) {
      return 'https://dd2-temp-img.s3.amazonaws.com/' + product.sku + '/0.jpg';
    }
  }

  toggleFloatingHeaderExpand() {
    // this.setState({ floatOpen: !this.state.floatOpen });
    this.props.productToggleFloatingHeader(!this.props.product.floatingHeaderOpen);
  }

  getFloatingAssembledMessageContent() {
    if(!this.isDiamondSelected() && !this.isSettingSelected()) {
      return <div className='fhMessage'>
        <div>Choose a diamond or setting to start building your ring.</div>
      </div>;
    } else if(!this.isDiamondSelected() && this.isSettingSelected()) {
      return <div className='fhMessage'>
        <div>Choose a diamond to complete your ring.</div>
      </div>;
    } else if(this.isDiamondSelected() && !this.isSettingSelected()) {
      return <div className='fhMessage'>
        <div>Choose a setting to complete your ring.</div>
      </div>;
    } else if(this.isDiamondSelected() && this.isSettingSelected()) {
      return <div className={'fhImageWrapper'}>
        <div className='fhMessage'>
          {'Your ' + this.props.product.selectedSetting.name + ' with ' + this.props.product.selectedDiamond.caratWeight + ' carat ' + this.props.product.selectedDiamond.shape + ' diamond'}
        </div>
        <div className='fhPrice'>${this.getCombinedPrice().toLocaleString()}</div>
        <div className='addToCartWrapper'>
          <div className={'addButton mixedResultsButton'} onClick={::this.props.scrollTop}>Customize</div>
        </div>
      </div>
    }
  }

  getCombinedPrice() {
    if(this.props.product.selectedSetting && this.props.product.selectedDiamond) {
      return this.props.product.selectedSetting.price + this.props.product.selectedDiamond.price;
    }
    return 1000;
  }

  render() {
    return <div className='FloatingHeader'>
      <div className={this.state.scrollPos > 400 ? 'floatingHeader open' : 'floatingHeader'}>
        <div className='backgroundSection'>
          <div className='labelSection'>
            <div className='labelTitle'>Create Your Ring</div>
            <div className='labelText compareLabel' onClick={::this.props.scrollCompare}>
              <div className='compareIcon'>
                <img src='https://ddw2.diamondsdirect.com/img/gallery/results/picks/compare_a.svg' />
              </div>
              <span>Comparing {this.props.getFavesLength()} of 4</span>
            </div>
            <div className='toggleWrapper' onClick={::this.toggleFloatingHeaderExpand}>
              <div className='toggleIcon' style={{display: this.props.product.floatingHeaderOpen ? 'none' : 'flex'}}>+</div>
              <div className='toggleIcon' style={{display: this.props.product.floatingHeaderOpen ? 'flex' : 'none'}}>&mdash;</div>
            </div>
          </div>
          <div className={this.props.product.floatingHeaderOpen ? 'fhOuterWrapper' : 'fhOuterWrapper closed'}>
            <div className={'fhWrapper'}>
              {this.isDiamondSelected() ?
                <div className='fhDiamondSection'>
                  <div className='removeX' onClick={() => this.props.productSelectDiamond(null)}>&times;</div>
                  <div className='imageWrapper'>
                      <img src={this.props.product.selectedDiamond.image} />
                  </div>
                  <div className='sectionWrapper'>
                    <div className='sectionName'>{this.isDiamondSelected() ? diamondTitle(this.props.product.selectedDiamond) : 'No diamond selected'}</div>
                    <div className='sectionPrice'>${this.isDiamondSelected() ? this.props.product.selectedDiamond.price.toLocaleString() : ''}</div>
                    <div className='sectionPriceNotice'>(diamond only)</div>
                    <div className='diamondInfoButtonRow'>
                      <div className={'mixedResultsButton fhButton'} onClick={() => this.internalNav('diamond/' + this.props.product.selectedDiamond.id)}>View</div>
                    </div>
                  </div>
                </div> :
                <div className='fhDiamondSection'>
                  <div className='fhMessage'>No diamond selected</div>
                  <div className='fhAction'></div>
                </div>
              }
              {this.isSettingSelected() ?
                <div className='fhSettingSection'>
                  <div className='removeX' onClick={() => this.props.productSelectSetting(null)}>&times;</div>
                  <div className='imageWrapper'>
                    <img src={this.isSettingSelected() ? this.getProductMainImage(this.props.product.selectedSetting) : '/img/ringbuilder/results/setting_sample.jpg'} />
                  </div>
                  <div className='sectionWrapper'>
                    <div className='sectionName'>{this.isSettingSelected() ? this.props.product.selectedSetting.name : 'Loading setting...'}</div>
                    <div className='sectionPrice'>${this.isSettingSelected() ? this.props.product.selectedSetting.price.toLocaleString() : ''}</div>
                    <div className='sectionPriceNotice'>(setting only)</div>
                    <div className='diamondInfoButtonRow'>
                      <div className={'mixedResultsButton fhButton'} onClick={() => this.internalNav('setting/' + this.props.product.selectedSetting.sku)}>View</div>
                    </div>
                  </div>
                </div> :
                <div className='fhSettingSection'>
                  <div className='fhMessage'>No setting selected</div>
                  <div className='fhAction'></div>
                </div>
              }
              <div className='fhImageSection'>
                {this.getFloatingAssembledMessageContent()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
  }
}
export default FloatingHeader;

function mapStateToProps(state) {
  return {
    product: state.product,
  };
}

export const FloatingHeaderContainer = connect(
  mapStateToProps,
  allActionCreators
)(FloatingHeader);


// WEBPACK FOOTER //
// ./src/components/views/gallery/blocks/blocks/FloatingHeader.jsx